(function() {
'use strict';

const FILTERLINKCONTENTTYPE = 11;

const TR = angular.module('TR');

TR.directive('destinationContent', function(broker, destinationContent, currentDestination, urlUtils, fidParser) {
    return {
        restrict: 'E',
        replace: false,
        scope: {
            containerClass: '@',
            sitemapLink: '='
        },
        templateUrl: 'partials/home/directivetemplate?type=DestinationContent',
        link(scope) {
            currentDestination.getCurrentDestination().then(function(dest) {
                if (dest != null) {
                    init(dest);
                }
            });

            function init(dest) {
                destinationContent.get(dest).then(function(contents) {
                    contents = _.sortBy(contents, contentOrderRank);
                    contents.forEach(function(content, index) {
                        if (Array.isArray(content.Items)) {
                            content.Items.forEach(function(item, name) {
                                if (!_.isNull(item.Url) && !_.isUndefined(item.Url)) {
                                    contents[index].Items[name].Url = urlUtils.stripLeadingSlash(item.Url);
                                }
                            });
                        }
                    });

                    // if the url we are being hit with matches one of the seo
                    // content urls, The fid is considered canonical.  Fire off
                    //a message to update the canonical tag.
                    const currentFid = fidParser.parse();

                    if (currentFid) {
                        const matchedSeoItem = _.find(contents, function(ci) {
                            if (ci.ContentType !== FILTERLINKCONTENTTYPE) {
                                return false;
                            }

                            return _.find(ci.Items, function(i) {
                                const parsedUrl = urlUtils.parse(i.Url);

                                // no query string object or parameters, exist early.
                                if (!parsedUrl.qs || parsedUrl.qs.length === 0) {
                                    return false;
                                }

                                return currentFid === _.toNumber(parsedUrl.qs.fid);
                            });
                        });

                        if (!_.isUndefined(matchedSeoItem)) {
                            broker.publish('seoCanonicalDetected', {
                                fid: currentFid
                            });
                        }
                    }

                    // Don't render filter link content.
                    scope.items = _.filter(contents, function(ci) {
                      return ci.ContentType !== FILTERLINKCONTENTTYPE;
                    });

                    broker.publish('seoContentLoaded');
                });
            }

            function contentOrderRank(content) {
                // The order should be:
                // First: SEO Content Types, in alphabetical order
                // Then: The other content types, in id order.
                if (content.ContentType > 7) {
                    return `0${content.Title}`;
                }
                return `1${content.ContentType}`;
            }
        }
    };
});
})();
